import { Injectable } from '@angular/core';

@Injectable()
export class LoggingService {

  logItems: string[] = [];

  constructor() { }

  // Logs messages to the console. Just a wrapper so we can control it's usage when deployed.
  log(logMessage: string, enabled: boolean) {

    if (logMessage)
      logMessage = logMessage.trim();
    else
      return;

    if (enabled && logMessage) {
      console.log(logMessage);
      //this.logItems.push(logMessage);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/logging-service/logging.service.ts